<template>
<div>
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Medios de Transporte" class="elevation-1 px-5 py-3" >
                    <v-card-text>
                        <v-dialog v-model="dialog" max-width="600px" >
                            <v-card>

                                <v-card-text>
                                    <h5>Medios de Transporte</h5>
                                    <h5 class="caption gray--text font-weight-light" >Seleccione el periodo</h5>
                                    <v-container grid-list-md text-xs-center>
                                        <v-form ref="form1" v-model="valid" lazy-validation>
                                            <v-row no-gutters dense>
                                                <v-col>
                                                    <v-menu offset-x ref="menuA1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                        <template v-slot:activator="{ on }" >
                                                            <v-text-field clearable v-on="on" v-model="fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="fecha_de = parseDate(fecha_de)" v-mask="'####-##-##'" :rules="[ validaFechas(fecha_de, fecha_a)]" ></v-text-field>
                                                        </template>

                                                        <v-date-picker v-model="fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false" >
                                                            <v-spacer />

                                                            <v-btn color="secondary" x-small @click="menu1 = false" >
                                                                Cancelar
                                                            </v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-col>
                                                <v-col>
                                                    <v-menu offset-x ref="menuA2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                        <template v-slot:activator="{ on }" >
                                                            <v-text-field clearable v-on="on" v-model="fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="fecha_a= parseDate(fecha_a)" v-mask="'####-##-##'" :rules="[ validaFechas(fecha_de, fecha_a)]" ></v-text-field>
                                                        </template>
                                                        <v-date-picker v-model="fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false" >
                                                            <v-spacer />

                                                            <v-btn color="secondary" x-small @click="menu2 = false" >
                                                                Cancelar
                                                            </v-btn>
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-col>

                                            </v-row>
                                        </v-form>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>

                                    <v-spacer></v-spacer>
                                    <v-btn small @click="dialog = false" >Cancelar</v-btn>
                                    <v-btn small :loading="loading" :disabled="loading || !valid" color="primary" @click="loader = 'loading'; loading=true; estadisticaGrafica1();" >Consultar</v-btn>

                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    
                        <br />
                        <v-tabs grow style="margin-bottom: 30px;" >
                            <v-tabs-slider color="primary" ></v-tabs-slider>
                            <v-tab :key="'in-impo'" >Importaciones</v-tab>
                            <v-tab :key="'in-expo'" >Exportaciones</v-tab>
                            <v-tab :key="'in-inc'" > INFORME DE INCREMENTABLES E IDENTIFICADORES DE TRANSPORTE</v-tab>
                            <v-tab-item :key="'in-impo'" >
                                <div ref="graficas_area1" >
                                <v-row ref="graficas_area" style="margin:0 !important; padding:0 !important" >

                                    <v-col cols="12" lg="5" style="padding-top:0px;" >
                                        <h4 class="mt-6 ml-2" >IMPORTACIONES POR MEDIO DE TRANSPORTE</h4>
                                        <base-material-chart-card :options="data_grafica1" color="white" type="Bar" >
                                            <h4 class="card-title font-weight-light mt-2 ml-2" ></h4>
                                        </base-material-chart-card>
                                    </v-col>

                                    <v-col cols="12" lg="7" style="padding-top:40px;" >
                                        <div v-if="print" class="d-inline-flex text-right" style=" z-index:1;    width:100%; padding-right:10px;" >
                                            <v-spacer />
                                                <span class="overline secondary--text font-weight-light " >PERIODO: {{fecha_de}} - {{fecha_a}}
                                                <v-btn small light icon title="Seleccionar Periodo" @click="dialog = !dialog" v-tippy>
                                                    <v-icon small color="secondary" >mdi-calendar</v-icon>
                                                </v-btn>

                                            </span>
                                            <exportar-excel :data="data_tableA" :exportFields="data_tableA_excel" name="Importaciones_MT.xlsx" >
                                                <v-btn  small icon color="green" title="Descargar Información" v-tippy>
                                                    <v-icon dark>mdi-table</v-icon>
                                                </v-btn>
                                            </exportar-excel>
                                              <v-btn small icon color="red" title="Descargar Gráficas PDF" @click="descargar_graficas(1)" v-tippy>
                                                <v-icon small  >picture_as_pdf</v-icon>
                                            </v-btn>
                                        </div>
                                        <v-client-table style="margin-top:0px;" ref="vuetableA" :data="data_tableA" :columns="columns_tableA" :options="tableA_options" class="elevation-2 pa-2 footer-hide" >
                                            <template slot="noResults" >
                                                <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                            </template>
                                          
                                             <div slot="descripcion" slot-scope="props" class="text-center" >
                                                <a v-if= "props.row.descripcion!='TOTAL'" @click="porAduana(props.row.descripcion, props.row.tipo_operacion)" >{{props.row.descripcion.substring(0, 13)}}</a>
                                                <b v-if= "props.row.descripcion=='TOTAL'" >{{props.row.descripcion.substring(0, 13)}}</b>
                                            </div>
                                            <div slot="pedimentos" slot-scope="props" class="text-end" :class="props.row.descripcion=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.pedimentos)}}</div>
                                            <div slot="peso_bruto" slot-scope="props" class="text-end" :class="props.row.descripcion=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.peso_bruto)}}</div>
                                            <div slot="valor_dls" slot-scope="props" class="text-end" :class="props.row.descripcion=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.valor_dls)}}</div>
                                            <div slot="valor_total" slot-scope="props" class="text-end" :class="props.row.descripcion=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.valor_total)}}</div>
                                            <div slot="rectificaciones" slot-scope="props" class="text-end" :class="props.row.descripcion=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.rectificaciones)}}</div>
                                            <div slot="peso_bruto_r" slot-scope="props" class="text-end" :class="props.row.descripcion=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.peso_bruto_r)}}</div>
                                            <div slot="valor_dls_r" slot-scope="props" class="text-end" :class="props.row.descripcion=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.valor_dls_r)}}</div>
                                            <div slot="valor_total_r" slot-scope="props" class="text-end" :class="props.row.descripcion=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.valor_total_r)}}</div>
                                        </v-client-table>

                                    </v-col>
                                </v-row>
                                <v-row ref="graficas_area" style="margin:0 !important; padding:0 !important" >

                                    <v-col cols="12" lg="5" style="padding-top:-10px;" >
                                        <div id="grafica3" v-if="data_tableC.length>0" style="margin-top:-40px;" class="text-left" >
                                            <base-material-chart-card :options="data_grafica3" color="white" type="Pie" >
                                                <h5 class="card-title font-weight-light mt-2 ml-2" ></h5>
                                            </base-material-chart-card>

                                        </div>
                                    </v-col>

                                    <v-col cols="12" lg="7" style="padding-top:20px;" >
                                        <div  id="grafica3" v-if="data_tableC.length>0 && print" >
                                            <v-card-actions style="padding:0; height:20px; margin-top:-28px" >
                                                <v-spacer></v-spacer>

                                                <v-btn color="black" icon title="Ocultar Tabla" @click="ocultaImpo()" v-tippy>
                                                    <v-icon dark>mdi-close</v-icon>
                                                </v-btn>
                                            </v-card-actions>
                                        </div>
                                        <br />
                                        <div v-if="data_tableC.length>0" class="d-inline-flex text-right" style=" z-index:1;    width:100% ; padding-right:10px;" >
                                            <h5 >{{titulo_detalle}}</h5>
                                            <v-spacer />
                                            <exportar-excel v-if="print"  :data="data_tableC" :exportFields="data_tableC_excel" name="Importaciones_Aduana_MT.xlsx" >
                                                <v-btn  small icon color="green" title="Descargar Información" v-tippy>
                                                    <v-icon dark>mdi-table</v-icon>
                                                </v-btn>
                                            </exportar-excel>
                                        </div>
                                        
                                        <v-client-table v-if="data_tableC.length>0" style="margin-top:0px; min-heigth:300px;" ref="vuetableB" :data="data_tableC" :columns="columns_tableC" :options="tableC_options" class="elevation-2 pa-2 footer-hide" >
                                            <template slot="noResults" >
                                                <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                            </template>
                                            <div slot="aduana" slot-scope="props" class="text-center" >
                                                <b  :title="nombre_aduana(props.row.aduana)" v-tippy>{{props.row.aduana}}</b>
                                            </div>   
                                            <div slot="pedimentos" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.pedimentos)}}</div>
                                            <div slot="peso_bruto" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.peso_bruto)}}</div>
                                            <div slot="valor_dls" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.valor_dls)}}</div>
                                            <div slot="valor_total" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.valor_total)}}</div>

                                            <div slot="rectificaciones" slot-scope="props" class="text-end" :class="props.row.descripcion=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.rectificaciones)}}</div>
                                            <div slot="peso_bruto_r" slot-scope="props" class="text-end" :class="props.row.descripcion=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.peso_bruto_r)}}</div>
                                            <div slot="valor_dls_r" slot-scope="props" class="text-end" :class="props.row.descripcion=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.valor_dls_r)}}</div>
                                            <div slot="valor_total_r" slot-scope="props" class="text-end" :class="props.row.descripcion=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.valor_total_r)}}</div>
                                        </v-client-table>

                                    </v-col>
                                </v-row>
                                </div>
                            </v-tab-item>
                            <v-tab-item :key="'in-expo'" >
                                <div ref="graficas_area2" >
                                <v-row ref="graficas_area" style="margin:0 !important; padding:0 !important" >

                                    <v-col cols="12" lg="5" style="padding-top:0px;" >
                                        <h4 class="mt-6 ml-2" >EXPORTACIONES POR MEDIO DE TRANSPORTE</h4>
                                        <div id="grafica2" >
                                            <base-material-chart-card :options="data_grafica2" color="white" type="Bar" >

                                                <h5 class="card-title font-weight-light mt-2 ml-2" ></h5>

                                            </base-material-chart-card>

                                        </div>
                                    </v-col>

                                    <v-col cols="12" lg="7" style="padding-top:60px;" >
                                        <div v-if="print" class="d-inline-flex text-right" style=" z-index:1;    width:100%" >
                                            <v-spacer />
                                             <span class="overline secondary--text font-weight-light " >PERIODO: {{fecha_de}} - {{fecha_a}}
                                                <v-btn small light icon title="Seleccionar Periodo" @click="dialog = !dialog" v-tippy>
                                                    <v-icon small color="secondary" >mdi-calendar</v-icon>
                                                </v-btn>

                                            </span>
                                            <exportar-excel :data="data_tableB" :exportFields="data_tableB_excel" name="Exportaciones_MT.xlsx" >
                                                <v-btn  small icon color="green" title="Descargar Información" v-tippy>
                                                    <v-icon dark>mdi-table</v-icon>
                                                </v-btn>
                                            </exportar-excel>
                                              <v-btn small icon color="red" title="Descargar Gráficas PDF" @click="descargar_graficas(2)" v-tippy>
                                                <v-icon small  >picture_as_pdf</v-icon>
                                            </v-btn>
                                        </div>
                                        <v-client-table style="margin-top:0px;" ref="vuetableB" :data="data_tableB" :columns="columns_tableB" :options="tableB_options" class="elevation-2 pa-2 footer-hide" >
                                            <template slot="noResults" >
                                                <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                            </template>
                                             <div slot="descripcion" slot-scope="props" class="text-center" >
                                                <a v-if= "props.row.descripcion!='TOTAL'" @click="porAduana(props.row.descripcion, props.row.tipo_operacion)" >{{props.row.descripcion.substring(0, 13)}}</a>
                                                <b v-if= "props.row.descripcion=='TOTAL'" >{{props.row.descripcion.substring(0, 13)}}</b>
                                            </div>
                                            <div slot="pedimentos" slot-scope="props" class="text-end" :class="props.row.descripcion=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.pedimentos)}}</div>
                                            <div slot="peso_bruto" slot-scope="props" class="text-end" :class="props.row.descripcion=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.peso_bruto)}}</div>
                                            <div slot="valor_dls" slot-scope="props" class="text-end" :class="props.row.descripcion=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.valor_dls)}}</div>
                                            <div slot="valor_total" slot-scope="props" class="text-end" :class="props.row.descripcion=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.valor_total)}}</div>

                                            <div slot="rectificaciones" slot-scope="props" class="text-end" :class="props.row.descripcion=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.rectificaciones)}}</div>
                                            <div slot="peso_bruto_r" slot-scope="props" class="text-end" :class="props.row.descripcion=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.peso_bruto_r)}}</div>
                                            <div slot="valor_dls_r" slot-scope="props" class="text-end" :class="props.row.descripcion=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.valor_dls_r)}}</div>
                                            <div slot="valor_total_r" slot-scope="props" class="text-end" :class="props.row.descripcion=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.valor_total_r)}}</div>
                                        </v-client-table>
                                    </v-col>
                                </v-row>
                                <v-row ref="graficas_area" style="margin:0 !important; padding:0 !important" >

                                        <v-col cols="12" lg="5" style="padding-top:-10px;" >
                                        <div id="grafica3" v-if="data_tableD.length>0" style="margin-top:-40px;" class="text-left" >
                                            <base-material-chart-card :options="data_grafica4" color="white" type="Pie" >
                                                <h5 class="card-title font-weight-light mt-2 ml-2" ></h5>
                                            </base-material-chart-card>

                                        </div>
                                    </v-col>

                                    <v-col cols="12" lg="7" style="padding-top:20px;" >
                                        <div id="grafica3" v-if="data_tableD.length>0 && print" >
                                            <v-card-actions style="padding:0; height:20px; margin-top:-38px" >
                                                <v-spacer></v-spacer>

                                                <v-btn  color="black" icon title="Ocultar Tabla" @click="ocultaExpo()" v-tippy>
                                                    <v-icon dark>mdi-close</v-icon>
                                                </v-btn>
                                            </v-card-actions>
                                        </div>
                                        <br />
                                        <div v-if="data_tableD.length>0" class="d-inline-flex text-right" style=" z-index:1;    width:100%; padding-right:10px;" >
                                            <h5 >{{titulo_detalle}}</h5>
                                            <v-spacer />
                                            <exportar-excel v-if="print" :data="data_tableD" :exportFields="data_tableD_excel" name="Exportaciones_Aduana_MT.xlsx" >
                                                <v-btn   x-small icon color="green" title="Descargar Información" v-tippy>
                                                    <v-icon dark>mdi-table</v-icon>
                                                </v-btn>
                                            </exportar-excel>
                                        </div>
                                        
                                        <v-client-table v-if="data_tableD.length>0" style="margin-top:0px;" ref="vuetableD" :data="data_tableD" :columns="columns_tableD" :options="tableD_options" class="elevation-2 pa-2 footer-hide" >
                                            <template slot="noResults" >
                                                <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                            </template>
                                            <div slot="aduana" slot-scope="props" class="text-center" >
                                                <b  :title="nombre_aduana(props.row.aduana)" v-tippy>{{props.row.aduana}}</b>
                                            </div> 
                                            <div slot="pedimentos" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.pedimentos)}}</div>
                                            <div slot="peso_bruto" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.peso_bruto)}}</div>
                                            <div slot="valor_dls" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.valor_dls)}}</div>
                                            <div slot="valor_total" slot-scope="props" class="text-end" :class="props.row.aduana=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.valor_total)}}</div>
                                            <div slot="rectificaciones" slot-scope="props" class="text-end" :class="props.row.descripcion=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.rectificaciones)}}</div>
                                            <div slot="peso_bruto_r" slot-scope="props" class="text-end" :class="props.row.descripcion=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.peso_bruto_r)}}</div>
                                            <div slot="valor_dls_r" slot-scope="props" class="text-end" :class="props.row.descripcion=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.valor_dls_r)}}</div>
                                            <div slot="valor_total_r" slot-scope="props" class="text-end" :class="props.row.descripcion=='TOTAL'?'font-weight-black':''" >{{formatNumber(props.row.valor_total_r)}}</div>
                                        </v-client-table>
                                    </v-col>
                                </v-row>
                                </div>
                            </v-tab-item>
                            <v-tab-item :key="'in-inc'" >
                                <incrementables ref="incrementables" ></incrementables>
                            </v-tab-item>
                        </v-tabs>

                      
                        <br/><br/><br/><br/>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
var colors_bars = [
    "green",
    "#ffde17", //amarillo
    "#eb7601", //naranja
    "lime", 
    "blue",
];
import axios from "axios";
import moment from "moment";
import Canvg from 'canvg';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import incrementables from "@/views/reportes/ReporteTransportesIncrementables";
window.html2canvas = html2canvas

export default {
    name: "DashboardDashboard",
    components: {
        incrementables,
    },
    watch: {

    },
    data() {
        return {
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Reportes",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Aduana - Patente",
                    disabled: true,
                    to: ""
                }
            ],
            valid: true,
            loader: null,
            loading: false,
            dialog: false,
            consultaG1: "",
            data_patentes: [],
            dialog1: false,
            g_impos: [],
            g_expos: [],
            menu1: false,
            menu2: false,
            fecha_de: "",
            fecha_a: "",
            a1: 2020,
            print: true,
            titulo_detalle:"",
            lista_aduanas: [],
            data_grafica1: {
                chart: {
                    type: "bar",
                    backgroundColor: '#fff',
                    height: 200,
                    spacingBottom: 2,
                    spacingTop: 2,
                    spacingLeft: 2,
                    spacingRight: 2,
                    marginRight: 2,
                    marginLeft: 90,
                    marginTop: 2,
                    marginBottom: 30,

                },

                credits: {
                    enabled: false
                },
                csecondaryits: false,
                title: {
                    text: ""
                },
                plotOptions: {
                    candlestick: {
                        lineColor: 'secondary'
                    }
                },
                navigator: {
                    yAxis: {
                        gridLineColor: '#000'
                    }
                },
                colors: colors_bars,
                xAxis: {
                    type: 'category'

                },

                yAxis: {
                    allowDecimals: false,
                    gridLineWidth: 1,
                    minorGridLineWidth: 1,
                    minorTicks: true,
                    min: 0,
                    title: {
                        text: "",
                    },
                    labels: {
                        style: {
                            color: '#000',
                            fontSize: '9px'
                        }
                    },
                },

                tooltip: {
                    formatter: function () {
                        return (
                            "Pedimentos: " + this.y +
                            "<br/>Peso Bruto: " + this.point.peso_bruto +
                            "<br/>Valor en Dolares: $" + this.point.valor_dls +
                            "<br/>Valor Total: $" + this.point.valor_total
                        );
                    }
                },

                plotOptions: {
                    column: {
                        stacking: "normal",
                    },
                    series: {

                        showInLegend: false
                    }
                },
                legend: {
                    enabled: false
                },
                series: []
            },
            data_grafica2: {
                chart: {
                    type: "bar",
                    backgroundColor: null,
                    height: 200,
                    spacingBottom: 2,
                    spacingTop: 2,
                    spacingLeft: 2,
                    spacingRight: 2,
                    marginRight: 2,
                    marginLeft: 90,
                    marginTop: 2,
                    marginBottom: 30,

                },

                credits: {
                    enabled: false
                },
                csecondaryits: false,
                title: {
                    text: ""
                },
                plotOptions: {
                    candlestick: {
                        lineColor: 'secondary'
                    }
                },
                navigator: {
                    yAxis: {
                        gridLineColor: '#000'
                    }
                },
                colors: colors_bars,
                xAxis: {
                    type: 'category'
                },

                yAxis: {
                    allowDecimals: false,
                    gridLineWidth: 1,
                    minorGridLineWidth: 1,
                    minorTicks: true,
                    min: 0,
                    title: {
                        text: "",
                    },
                    labels: {
                        style: {
                            color: '#000',
                            fontSize: '9px'
                        }
                    },
                },

                tooltip: {
                    formatter: function () {
                        return (
                            "Pedimentos: " + this.y +
                            "<br/>Peso Bruto: " + this.point.peso_bruto +
                            "<br/>Valor en Dolares: $" + this.point.valor_dls +
                            "<br/>Valor Total: $" + this.point.valor_total
                        );
                    }
                },

                plotOptions: {
                    column: {
                        stacking: "normal"
                    }
                },
                legend: {
                    enabled: false
                },
                series: [

                ]
            },
            data_grafica3: {

                credits: {
                    enabled: false
                },
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: 'pie',
                    height: 300,
                    backgroundColor: null,
                },
                title: {
                    text: 'DETALLE POR ADUANA'
                },
                 tooltip: {
                    formatter: function () {
                        return (
                            "<b>Aduana:</b> " + this.point.aduana +
                            "<br/><b>Pedimentos:</b> " + this.y +
                            "<br/><b>Peso Bruto:</b> " + this.point.peso_bruto +
                            "<br/><b>Valor en Dolares:</b> $" + this.point.valor_dls +
                            "<br/><b>Valor Total:</b> $" + this.point.valor_total
                        );
                    }
                },
                accessibility: {
                    point: {
                        valueSuffix: '%'
                    }
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            format: '<b>{point.name}</b>:  {point.percentage:.1f} %'
                        }
                    }
                },
                series: [{
                    name: 'Pedimentos',
                    colorByPoint: true,
                    data: []
                }]
            },
            data_grafica4: {

                credits: {
                    enabled: false
                },
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: 'pie',
                    height: 300,
                },
                title: {
                    text: 'DETALLE POR ADUANA'
                },
                tooltip: {
                    formatter: function () {
                        return (
                            "<b>Aduana:</b> " + this.point.aduana +
                            "<br/><b>Pedimentos:</b> " + this.y +
                            "<br/><b>Peso Bruto:</b> " + this.point.peso_bruto +
                            "<br/><b>Valor en Dolares:</b> $" + this.point.valor_dls +
                            "<br/><b>Valor Total:</b> $" + this.point.valor_total
                        );
                    }
                },
                accessibility: {
                    point: {
                        valueSuffix: '%'
                    }
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                        }
                    }
                },
                series: [{
                    name: 'Pedimentos',
                    colorByPoint: true,
                    data: []
                }]
            },

            data_tableA: [],
            data_tableB: [],
            data_tableC: [],
            data_tableD: [],

            columns_tableA: [
                "descripcion",
                "pedimentos",
                "peso_bruto",
                "valor_dls",
                "valor_total",
                "rectificaciones"
            ],
            tableA_options: {
                filterable: false,
                filterByColumn: false,
                perPage: 100,
                texts: {
                    count: ''
                },
                headings: {
                    "descripcion": "Medio de Transporte",
                    "pedimentos": "Pedimentos",
                    "peso_bruto" : "Peso Bruto",
                    "valor_dls" : "Valor DLS",
                    "valor_total" : "Valor MN",
                    "rectificaciones": "Rectificaciones"
                }
            },
            data_tableA_excel: {
                "Medio de Transporte": "descripcion",
                "Pedimentos": "pedimentos",
                "Peso Bruto": "peso_bruto",
                "Valor DLS": "valor_dls",
                "Valor MN": "valor_total",
                "Rectificaciones": "rectificaciones",
                 "Peso Bruto R.": "peso_bruto_r",
                 "Valor DLS R.": "valor_dls_r",
                 "Valor MN R.": "valor_total_r",
            },
            columns_tableB: [
                "descripcion",
                "pedimentos",
                "peso_bruto",
                "valor_dls",
                "valor_total",
                "rectificaciones",
            ],
            tableB_options: {
                filterable: false,
                filterByColumn: false,
                perPage: 100,
                headings: {
                    "descripcion": "Medio de Transporte",
                    "pedimentos": "Pedimentos",
                    "peso_bruto" : "Peso Bruto",
                     "valor_dls" : "Valor DLS",
                    "valor_total" : "Valor MN",
                    "rectificaciones": "Rectificaciones"
                }
            },
            data_tableB_excel: {
                "Medio de Transporte": "descripcion",
                "Pedimentos": "pedimentos",
                "Peso Bruto": "peso_bruto",
                "Valor DLS": "valor_dls",
                "Valor MN": "valor_total",
                "Rectificaciones": "rectificaciones",
                 "Peso Bruto R.": "peso_bruto_r",
                 "Valor DLS R.": "valor_dls_r",
                 "Valor MN R.": "valor_total_r",
            },
            columns_tableC: [
                "aduana",
                "pedimentos",
                "peso_bruto",
                "valor_dls",
                "valor_total",
                   "rectificaciones"
            ],
            tableC_options: {
                filterable: false,
                perPage: 100,
                filterByColumn: false,
                headings: {
                    "aduana": "Aduana",
                    "pedimentos": "Pedimentos",
                    "peso_bruto" : "Peso Bruto",
                     "valor_dls" : "Valor DLS",
                    "valor_total" : "Valor MN",
                    "rectificaciones": "Rectificaciones",
                }
            },
            data_tableC_excel: {
                "Aduana": "aduana",
                "Pedimentos": "pedimentos",
                "Peso Bruto": "peso_bruto",
                "Valor DLS": "valor_dls",
                "Valor MN": "valor_total",
                "Rectificaciones": "rectificaciones",
                 "Peso Bruto R.": "peso_bruto_r",
                 "Valor DLS R.": "valor_dls_r",
                 "Valor MN R.": "valor_total_r",
            },
            columns_tableD: [
                "aduana",
                "pedimentos",
                "peso_bruto",
                "valor_dls",
                "valor_total",
                   "rectificaciones"
            ],
            tableD_options: {
                filterable: false,
                filterByColumn: false,
                perPage: 100,
                headings: {
                    "aduana": "Aduana",
                    "pedimentos": "Pedimentos",
                    "peso_bruto" : "Peso Bruto",
                     "valor_dls" : "Valor DLS",
                    "valor_total" : "Valor MN",
                    "rectificaciones": "Rectificaciones"
                }
            },
            data_tableD_excel: {
                "Aduana": "aduana",
                "Pedimentos": "pedimentos",
                "Peso Bruto": "peso_bruto",
                "Valor DLS": "valor_dls",
                "Valor MN": "valor_total",
                "Rectificaciones": "rectificaciones",
                 "Peso Bruto R.": "peso_bruto_r",
                 "Valor DLS R.": "valor_dls_r",
                 "Valor MN R.": "valor_total_r",
            },
            
            

        };
    },

    computed: {

    },
    mounted() {

    },
    async created() {

        var f_de = new Date();
        var f_a = new Date();

        f_de.setDate(f_de.getDate() - 7);

        let y = f_a.getFullYear();
        let m = f_a.getMonth() + 1;
        let d = f_a.getDate();

        let y_de = f_de.getFullYear();

        if (m < 10)
            m = '0' + m;
        if (d < 10)
            d = '0' + d;

        let fecha_a = y + "-" + m + "-" + d;
        let fecha_de = y_de + "-01-01";
        this.fecha_a = fecha_a;
        this.fecha_de = fecha_de;
        this.llenaraduanas();
        await this.estadisticaGrafica1();

    },
    methods: {
        ocultaExpo() {
            this.data_tableD = [];
        },
        ocultaImpo() {
            this.data_tableC = [];
        },
        formatNumber: function (x) {
            if (x == undefined) return 0;


            if(x - parseInt(x) >0)
                x= parseFloat(x).toFixed(2);

            x = x.toString();

            var pattern = /(-?\d+)(\d{3})/;
            while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
            return x;
        },
        filterResult() {
            Event.$emit('vue-tables.filter::filtro', this.filtro);
        },
        complete(index) {
            this.list[index] = !this.list[index];
        },
        nombre_aduana(aduana) {

            let r = this.lista_aduanas.filter(data => data.clave == aduana );
           
            if(r.length>0)
                return r[0].nombre;
            else 
                return "";
        },
        llenaraduanas(){
            
            axios.get(this.$hostname + 'catalogos/aduanas/')
                        .then((response) => {
                            this.lista_aduanas = response.data;
                        })
                        .catch((error) => {
                            console.log(error);
                        });
        },
        porAduana(desc, tipo) {
            this.data_tableC = [];
            this.titulo_detalle= desc;
            console.log(tipo);
            let self = this;
            let tpe = 0;
            let tpb = 0;
            let tvd = 0;
            let tvt = 0;
            if (tipo == "importaciones") {

                this.data_tableC = this.g_impos[desc].sort(function (a, b) {
                    return a.aduana - b.aduana ;
                });
                let data = [];
                 
                this.data_tableC.forEach(
                    function (item) {
                        data.push({
                            name: item.aduana,
                            y: item.pedimentos,
                            'peso_bruto': self.formatNumber(item.peso_bruto) ,
                            'aduana': self.nombre_aduana(item.aduana),
                            'valor_dls': self.formatNumber(item.valor_dls) ,
                            'valor_total': self.formatNumber(item.valor_total) 
                        });
                        tpe += item.pedimentos;
                        tpb += item.peso_bruto;
                        tvd += item.valor_dls;
                        tvt += item.valor_total;
                    }
                );
               /*  this.data_tableC.push({
                                'tipo_operacion': "importaciones",
                                'aduana': 'TOTAL',
                                'pedimentos': tpe,
                                'peso_bruto': tpb,
                                'valor_dls': tvd,
                                'valor_total': tvt
                            }); */
                this.data_grafica3.series[0].data = data;
            } else {

                this.data_tableD = this.g_expos[desc].sort(function (a, b) {
                    return a.aduana - b.aduana;
                });
                let data = [];
                this.data_tableD.forEach(
                    function (item) {
                        data.push({
                            name: item.aduana,
                            y: item.pedimentos,
                            'peso_bruto': self.formatNumber(item.peso_bruto) ,
                            'aduana': self.nombre_aduana(item.aduana),
                            'valor_dls': self.formatNumber(item.valor_dls) ,
                            'valor_total': self.formatNumber(item.valor_total) 
                        });
                        tpe += item.pedimentos;
                        tpb += item.peso_bruto;
                        tvd += item.valor_dls;
                        tvt += item.valor_total;
                    }
                );
           /*      this.data_tableD.push({
                                'tipo_operacion': "importaciones",
                                'aduana': 'TOTAL',
                                'pedimentos': tpe,
                                'peso_bruto': tpb,
                                'valor_dls': tvd,
                                'valor_total': tvt
                            }); */
                this.data_grafica4.series[0].data = data;
                 
            }

        },
        async estadisticaGrafica1() {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                "rfc": this.$local_storage.get("rfc"),
                "fecha_de": this.fecha_de,
                "fecha_a": this.fecha_a
            }
            let selft = this;
            await axios.post(this.$hostname + 'reportes/mediotransporte_aduana/', datos)
                .then((response) => {
                    selft.data_tableA = [];
                    selft.data_tableB = [];
                    let r = response.data;

                    let impos = [];
                    let expos = [];
                    r = r.sort(function (a, b) {
                        return a.descripcion - b.descripcion ;
                    });

                    r.forEach(
                        function (item) {
                            if (item.tipo_operacion == "Importaciones") {
                                impos.push(item);
                            } else {
                                expos.push(item);
                            }
                        });

                    selft.g_impos = impos.reduce((r, a) => {

                        r[a.descripcion] = [...r[a.descripcion] || [], a];

                        return r;
                    }, {});
                    selft.g_expos = expos.reduce((r, a) => {
                        r[a.descripcion] = [...r[a.descripcion] || [], a];
                        return r;
                    }, {});

                    let medios_impo = Object.keys(this.g_impos);
                    let medios_expo = Object.keys(this.g_expos);
                    let data = [];
                    let tpe = 0;
                    let tpb = 0;
                    let tvd = 0;
                    let tvt = 0;
                    let tre = 0;
                    let tpbr= 0;
                    let tvdr = 0;
                    let tvtr = 0;
                    medios_impo.forEach(
                        function (item) {
                            let pe = 0;
                            let pb = 0;
                            let vd = 0;
                            let vt = 0;
                            let re = 0;
                            let pbr = 0;
                            let vdr = 0;
                            let vtr = 0;
                            selft.g_impos[item].forEach(
                                function (item) {
                                    pe += item.pedimentos;
                                    pb += item.peso_bruto;
                                    vd += item.valor_dls;
                                    vt += item.valor_total;
                                    tpe += item.pedimentos;
                                    tpb += item.peso_bruto;
                                    tvd += item.valor_dls;
                                    tvt += item.valor_total;
                                    re += item.rectificaciones;
                                    pbr += item.peso_bruto_r;
                                    vdr += item.valor_dls_r;
                                    vtr += item.valor_total_r;
                                    tre += item.rectificaciones;
                                    tpbr += item.peso_bruto_r;
                                    tvdr += item.valor_dls_r;
                                    tvtr += item.valor_total_r;
                                });
                            data.push({
                                name: item.substring(0, 13),
                                y: pe,
                                peso_bruto: selft.formatNumber(pb),
                                valor_dls: selft.formatNumber(vd),
                                valor_total: selft.formatNumber(vt)
                            });
                            selft.data_tableA.push({
                                'tipo_operacion': "importaciones",
                                'descripcion': item,
                                'pedimentos': pe,
                                'peso_bruto': pb,
                                'valor_dls': vd,
                                'valor_total': vt,
                                'rectificaciones': re,
                                'peso_bruto_r': pbr,
                                'valor_dls_r': vdr,
                                'valor_total_r': vtr,
                            });

                        });
                        selft.data_tableA.push({
                                'tipo_operacion': "importaciones",
                                'descripcion': 'TOTAL',
                                'pedimentos': tpe,
                                'peso_bruto': tpb,
                                'valor_dls': tvd,
                                'valor_total': tvt,
                                'rectificaciones': tre,
                                'peso_bruto_r': tpbr,
                                'valor_dls_r': tvdr,
                                'valor_total_r': tvtr
                            });
                    this.data_grafica1.series = [{
                        name: "Medios de Transporte",
                        colorByPoint: true,
                        data: data
                    }];

                    data = [];
                    tpe = 0;
                    tpb = 0;
                    tvd = 0;
                    tvt = 0;
                    tre = 0;
                    tpbr= 0;
                    tvdr = 0;
                    tvtr = 0;
                    medios_expo.forEach(
                        function (item) {
                            let pe = 0;
                            let pb = 0;
                            let vd = 0;
                            let vt = 0;
                            let re = 0;
                            let pbr = 0;
                            let vdr = 0;
                            let vtr = 0;
                            selft.g_expos[item].forEach(
                                function (item) {
                                    pe += item.pedimentos;
                                    pb += item.peso_bruto;
                                    vd += item.valor_dls;
                                    vt += item.valor_total;
                                    tpe += item.pedimentos;
                                    tpb += item.peso_bruto;
                                    tvd += item.valor_dls;
                                    tvt += item.valor_total;
                                    re += item.rectificaciones;
                                    pbr += item.peso_bruto_r;
                                    vdr += item.valor_dls_r;
                                    vtr += item.valor_total_r;
                                    tre += item.rectificaciones;
                                    tpbr += item.peso_bruto_r;
                                    tvdr += item.valor_dls_r;
                                    tvtr += item.valor_total_r;
                                });
                            data.push({
                                name: item.substring(0, 13),
                                y: pe,
                                peso_bruto: selft.formatNumber(pb),
                                valor_dls: selft.formatNumber(vd),
                                valor_total: selft.formatNumber(vt)
                            });
                            selft.data_tableB.push({
                                'tipo_operacion': "exportaciones",
                                'descripcion': item,
                                'pedimentos': pe,
                                'peso_bruto': pb,
                                'valor_dls': vd,
                                'valor_total': vt,
                                'rectificaciones': re,
                                'peso_bruto_r': pbr,
                                'valor_dls_r': vdr,
                                'valor_total_r': vtr,
                            });

                        });
                        selft.data_tableB.push({
                                'tipo_operacion': "exportaciones",
                                'descripcion': 'TOTAL',
                                'pedimentos': tpe,
                                'peso_bruto': tpb,
                                'valor_dls': tvd,
                                'valor_total': tvt,
                                'rectificaciones': tre,
                                'peso_bruto_r': tpbr,
                                'valor_dls_r': tvdr,
                                'valor_total_r': tvtr
                            });
                    this.data_grafica2.series = [{
                        name: "Medios de Transporte",
                        colorByPoint: true,
                        data: data
                    }];

                })
                .catch((error) => {
                    console.log(error);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.dialog = false;
                    this.loader = null;
                    this.loading = false;
                });
        },

        validaFechas: function (FD, FA) {
            if (FD == null)
                FD = ""
            if (FA == null)
                FA = ""

            if (FD != "" && FD == "") {
                return "Debe seleccionar las dos fechas o ninguna."
            } else if (FD == "" && FA != "") {
                return "Debe seleccionar las dos fechas o ninguna."
            }
            return true;
        },

        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
       
         async descargar_graficas(tipo) {
             this.print = false;
              var pdf = new jsPDF('l', 'pt');
             var el = ""
             var name = "";
             var alto = 280;
              if (tipo==1){
                   el = this.$refs.graficas_area1;
                   name = "Aduana_Patente_Importaciones.pdf";
                   if (this.data_tableC.length > 0)
                    alto = 370;
              }else{
                   el = this.$refs.graficas_area2;
                   name = "Aduana_Patente_Exportaciones.pdf";
                   if (this.data_tableD.length > 0)
                    alto = 370;
              }
              

              const options = {
                  type: 'dataURL'
                }
              var url = await this.$html2canvas(el, options);

              
                pdf.setFontSize(20);
                pdf.addImage(url, 'PNG', 20, 80, 800, alto);
                pdf.save(name);
           this.print = true;

        },

    }
};
</script>

<style scoped>
.footer-hide>>>.VuePagination {
    display: none;
}

.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
    color: black;
    font-size: small;
    background-color: #EEEEEE;
    padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small;
    background-color: #df7205;
    padding: 0px;
    font-weight: bold;

}

.v-tabs-slider-wrapper {
    left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
    font-size: x-small !important;
}
</style>
